import { Button, Col, notification, Row, Spin, Table, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import ImageDisplayer from "../../../../../utils/ImageDisplayer";
import { CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import { useLanguage } from "../../../../../../context/LanguageContext";
import { ClassesShow, PositionSecured } from "../../../../../../models/Security";
import SweepPictureService from "../../../../../../services/PictureService";
import SweepThumbnailService from "../../../../../../services/ThumbnailService";

interface SummaryTableProps {
  updateContent: () => void;
  positions: PositionSecured[];
  sweepId: number;
  classes: ClassesShow[];
}

const SummaryTable = (props: SummaryTableProps) => {
  const { language } = useLanguage();
  const [pageSize, setPageSize] = useState<number>(10);

  useEffect(() => {

  }, []);

  let columns = [
    {
      title: language === "es" ? "Etiqueta de Posición" : "Position Label",
      key: "position_label",
      width: 120,
      render: (item: PositionSecured) => {
        return (
          <Tag>{item.position_label}</Tag>
        );
      },
    },
    {
      title: language === "es" ? "Imagen de Posición" : "Position Image",
      key: "image_position",
      width: 120,
      render: (item: PositionSecured) => {
        return (
          <ImageDisplayer
            position_label={item.position_label}
            fetchFunction={() => {
              const paddedPositionLabel = item.position_label.padStart(5, " ");
              return SweepPictureService.getSweepPositionPicture(
                props.sweepId,
                paddedPositionLabel
              );
            }}
            lowfetchFuntion={(abortSignal: AbortSignal) => {
              const paddedPositionLabel = item.position_label.padStart(5, " ");
              return SweepThumbnailService.getSweepPositionThumbnail(
                props.sweepId,
                paddedPositionLabel,
                abortSignal
              );
            }}
            height={"50px"}
            width={"88.88px"}
          />
        );
      },
    },
    {
      title: language === "es" ? "Etiqueta de Pallet" : "Pallet Label",
      key: "pallet_label",
      width: 120,
      render: (item: PositionSecured) =>
        <Tag>
          {item.state === "empty" ? language === "es" ? "VACÍA" : "EMPTY" : item.pallet_label}
        </Tag>
      ,
    },
    {
      title: language === "es" ? "Imagen de Pallet" : "Pallet Image",
      key: "image_pallet",
      width: 120,
      render: (item: PositionSecured) => {
        return (
          <ImageDisplayer
            position_label={item.position_label}
            fetchFunction={() => {
              const paddedPositionLabel = item.position_label.padStart(5, " ");
              return SweepPictureService.getSweepPalletPicture(
                props.sweepId,
                paddedPositionLabel
              );
            }}
            lowfetchFuntion={(abortSignal: AbortSignal) => {
              const paddedPositionLabel = item.position_label.padStart(5, " ");
              return SweepThumbnailService.getSweepPalletThumbnail(
                props.sweepId,
                paddedPositionLabel,
                abortSignal
              );
            }}
            height={"50px"}
            width={"88.88px"}
          />
        );
      },
    },
    {
      title: language === "es" ? "Estado" : "State",
      key: "security_status",
      width: 120,
      render: (item: PositionSecured) => {

        const showstatus = language === "es"
          ? item.security_status === "safe"
            ? "seguro"
            : item.security_status === "caution"
              ? "precaución"
              : item.security_status === "risky"
                ? "riesgoso"
                : item.security_status === "critical"
                  ? "crítico"
                  : item.security_status
          : item.security_status;
        let tagColor = "default";
        const classItem = props.classes.find((cls) => cls.name === item.security_status);
        if (classItem) {
          tagColor = classItem.color;
        } else {
          tagColor = "yellow";
        }
        return <Tag color={tagColor} style={{ fontSize: "14px" }}>{showstatus}</Tag>;
      },
    },
    // {
    //   title: language === "es" ? "Acciones" : "Actions",
    //   key: "actions",
    //   width: 100,
    // render: (item: UntrackedPositionShowSchema) => {
    //   return <Row gutter={[10, 10]} >
    //     <Col xs={12} sm={12} md={12} lg={12} >
    //       <Tooltip title={language === "es" ? "Agregar" : "Add"}>
    //         <Button
    //           disabled={item.tracking_status === "accepted"|| item.uploaded|| props.sweepStatus !== "processing"}
    //           style={{ backgroundColor: (props.sweepStatus == "processing"&&item.tracking_status !== "accepted"&& item.uploaded===false ? "#73d13d" : "") }}
    //           type="primary"
    //           shape="round"
    //           icon={<CheckCircleOutlined />}
    //           onClick={() => {
    //             SweepService.setUntrakedPositon(props.sweepId.toString(), "add", item.idx).then((res) => {
    //               if (res === "OK") {
    //                 notification.success({
    //                   message: language === "es" ? "Éxito" : "Success",
    //                   description: language === "es"
    //                     ? "Posición agregada correctamente."
    //                     : "Position add successfully.",
    //                 });
    //                 props.updateContent();
    //               } else {
    //                 notification.error({
    //                   message: language === "es" ? "Error" : "Error",
    //                   description: language === "es"
    //                     ? "No se pudo agregar la posición."
    //                     : "Failed to add position.",
    //                 });
    //               }
    //             });
    //           }}
    //         />
    //       </Tooltip>
    //     </Col>
    //     <Col xs={12} sm={12} md={12} lg={12} >
    //       <Tooltip title={language === "es" ? "Descartar" : "Discard"}>
    //         <Button
    //           disabled={item.tracking_status === "rejected" || item.uploaded||props.sweepStatus !== "processing"}
    //           style={{ backgroundColor: (props.sweepStatus == "processing"&&item.tracking_status !== "rejected"&& item.uploaded===false? "#ff4d4f" : "") }}
    //           type="primary"
    //           shape="round"
    //           icon={<StopOutlined />}
    //           onClick={() => {
    //             SweepService.setUntrakedPositon(props.sweepId.toString(), "discard", item.idx).then((res) => {
    //               if (res === "OK") {
    //                 notification.success({
    //                   message: language === "es" ? "Éxito" : "Success",
    //                   description: language === "es"
    //                     ? "Posición descartada correctamente."
    //                     : "Position discarded successfully.",
    //                 });
    //                 props.updateContent();
    //               } else {
    //                 notification.error({
    //                   message: language === "es" ? "Error" : "Error",
    //                   description: language === "es"
    //                     ? "No se pudo descartar la posición."
    //                     : "Failed to discard position.",
    //                 });
    //               }
    //             });
    //           }}
    //         />
    //       </Tooltip>
    //     </Col>
    //   </Row>;
    // }
    // },

  ]

  const paginationConfig = {
    pageSize: pageSize,
    total: props.positions.length,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50"],
    onChange: (page: number, pageSize: number | undefined) => {
      if (pageSize) {
        setPageSize(pageSize);
      }
    },
  };


  return (
    <Spin spinning={false}>
      <Table
        columns={columns}
        dataSource={props.positions}
        rowKey="id"
        scroll={{ x: (1000) }}
        size="small"
        pagination={paginationConfig}
        showSorterTooltip={true}

      />
    </Spin>
  );
};

export default SummaryTable;
